/* @flow */

import * as React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ClockThin from './clock-thin-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ClockThin {...validProps} />;
}
SvgComponent.iconName = 'clockThin';

export const ClockThinIcon = svgIconWrapper(SvgComponent);
